module.exports = __webpack_public_path__ + "static/scale-model-of-gerald-d.-hines-waterwall-park-in-houston-texas-5dceed358ab2e0ae5f29320e2bb8ef58.png";